(function(window) {
  if (window.Greenleaze && window.Greenleaze.version) {
    return;
  }

  var monthValues = [1, 12, 24, 36];
  var priceRules = [];
  var tva = 1.2;
  var trackingId = null;
  var listenersBound = false;
  var isFetchingRules = null;
  var eventName = "greenleazePriceActualize";

  function dispatchPriceEvent(detail) {
    window.dispatchEvent(new CustomEvent(eventName, { detail: detail || {} }));
  }

  function parseRule(rule, values) {
    if (!rule) {
      return function() {
        return 0;
      };
    }

    var expression = String(rule).replace(/\[\[(\w+)\]\]/g, function(_, key) {
      return values[key];
    });

    return new Function("return (" + expression + ");");
  }

  function normalizeNumber(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getRuleByProductPriceAndDuration(productPriceHT, duration) {
    var normalizedDuration = monthValues.includes(duration)
      ? duration
      : monthValues[monthValues.length - 1];
    var normalizedPrice = normalizeNumber(productPriceHT);
    var rule = priceRules.find(function(priceRule) {
      return (
        Number(priceRule.duration) === Number(normalizedDuration) &&
        Number(priceRule.minPrice) <= normalizedPrice &&
        Number(priceRule.maxPrice) >= normalizedPrice
      );
    });

    if (!rule) {
      console.error("No price rule found", {
        duration: normalizedDuration,
        productPriceHT: normalizedPrice,
      });
      return null;
    }

    try {
      var monthlyRule = parseRule(rule.rule, { tva: tva, prixHT: normalizedPrice });
      var depositRule = parseRule(rule.depositRule, { tva: tva, prixHT: normalizedPrice });

      return {
        monthly: normalizeNumber(monthlyRule()),
        initial: normalizeNumber(depositRule()),
      };
    } catch (error) {
      console.error("Unable to evaluate Greenleaze rule", error);
      return null;
    }
  }

  function getAllPricesForProduct(productPriceHT) {
    return monthValues.reduce(function(result, month) {
      var price = getRuleByProductPriceAndDuration(productPriceHT, month);
      if (price) {
        result[String(month)] = price;
      }
      return result;
    }, {});
  }

  function bindRefreshListeners() {
    if (listenersBound) {
      return;
    }

    listenersBound = true;

    [
      "on:cart:add",
      "on:line-item:change",
      "dispatch:cart-drawer:refresh",
      "on:cart:error",
    ].forEach(function(eventToWatch) {
      document.addEventListener(eventToWatch, function() {
        window.setTimeout(function() {
          dispatchPriceEvent({ source: eventToWatch });
        }, 300);
      });
    });
  }

  async function getAllPriceRules() {
    if (isFetchingRules) {
      return isFetchingRules;
    }

    isFetchingRules = fetch("/apps/greenleaze-proxy/pricing", {
      method: "GET",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      },
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Unable to load Greenleaze pricing rules");
        }
        return response.json();
      })
      .then(function(rules) {
        priceRules = Array.isArray(rules) ? rules : [];
        monthValues = Array.from(
          new Set(
            priceRules
              .map(function(rule) {
                return Number(rule.duration);
              })
              .filter(Boolean),
          ),
        ).sort(function(a, b) {
          return a - b;
        });

        if (!monthValues.length) {
          monthValues = [1, 12, 24, 36];
        }

        window.initPriceGreenleaze = true;
        window.rawrules = rules;
        bindRefreshListeners();
        dispatchPriceEvent({ source: "pricing" });
        return priceRules;
      })
      .catch(function(error) {
        window.initPriceGreenleaze = false;
        console.error("Greenleaze pricing initialization failed", error);
        throw error;
      })
      .finally(function() {
        isFetchingRules = null;
      });

    return isFetchingRules;
  }

  async function addTo(variantId, quantity) {
    console.log('fetch post')
    var response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    });
    console.log('response', response);
    if (!response.ok) {
      var errorPayload = null;
      try {
        errorPayload = await response.json();
      } catch (error) {
        errorPayload = null;
      }

      throw new Error(
        errorPayload?.description ||
          errorPayload?.message ||
          "Erreur pendant l'ajout au panier.",
      );
    }

    return response.json();
  }

  async function getCart() {
    var response = await fetch(window.Shopify.routes.root + "cart.js");
    return response.json();
  }

  async function ensureVariantInCart(variantId) {
    if (!variantId) {
      return getCart();
    }

    var cartContents = await getCart();
    var existingLine = cartContents.items.find(function(item) {
      return Number(item.variant_id) === Number(variantId);
    });

    if (existingLine && Number(existingLine.quantity) > 0) {
      return cartContents;
    }

    await addTo(variantId, 1);
    cartContents = await getCart();

    existingLine = cartContents.items.find(function(item) {
      return Number(item.variant_id) === Number(variantId);
    });

    if (!existingLine || Number(existingLine.quantity) < 1) {
      throw new Error("Le produit n'a pas pu etre ajoute au panier.");
    }

    return cartContents;
  }

  function getTrackingId() {
    if (!trackingId) {
      trackingId =
        window.greenleaze_tracking ||
        window.ShopifyAnalytics?.lib?.user?.()?.traits?.()?.uniqToken ||
        window.crypto?.randomUUID?.() ||
        null;
      window.greenleaze_tracking = trackingId;
    }

    return trackingId;
  }

  /* Point de passage obligé de TOUTES les redirections (bouton principal, barre
     collante, modale GreenLeaze). L'événement de conversion est publié ici, et
     nulle part ailleurs : c'est le seul moyen de n'en rater aucune et de ne pas
     en compter deux. */
  function publishRentalStarted(duration, variantId) {
    if (!window.LTMTracking) {
      return;
    }

    var product = window.LTMProduct || {};
    var pricing = (product.prices || {})[duration] || {};
    var monthly = pricing.monthly || null;
    var months = Number(duration) || 0;

    window.LTMTracking.publish('ltm_rental_started', {
      event_id: window.LTMTracking.newEventId(),
      product_id: product.product_id || null,
      product_title: product.product_title || null,
      variant_id: variantId || product.variant_id || null,
      duration_months: months,
      monthly_price: monthly,
      initial_payment: pricing.initial || null,
      /* Valeur du contrat, pas le loyer : une location 24 mois ne vaut pas
         la même chose qu'une 6 mois pour l'algorithme. */
      contract_value: monthly ? Math.round(monthly * months * 100) / 100 : null,
      currency: 'EUR',
    });
  }

  async function sendCartAndRedirect(duration, variantId, pdistinctId) {
    publishRentalStarted(duration, variantId);

    try {
      var cartContents = await ensureVariantInCart(variantId);
      var ack = await fetch("/apps/greenleaze-proxy/send-card", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cartContents: JSON.stringify(cartContents),
          duration: duration,
          trackingId: getTrackingId(),
          /* Identifiants de clic (gclid, fbclid...) : GreenLeaze doit nous les
             renvoyer à la validation du dossier pour réattribuer la location
             à la campagne. Sans ça, la conversion est perdue à la redirection. */
          trackingData: window.LTMTracking ? window.LTMTracking.get() : null,
          postHogtrackingId: pdistinctId,
          themeParams: {
            bannerArg1: window?.partnerCompany?.discountAmount,
            bannerArg2: window?.partnerCompany?.companyName,
          },
          returnUrl: window.Shopify.routes.root,
        }),
      });

      var payload = null;
      try {
        payload = await ack.json();
        console.log(payload);
      } catch (error) {
        payload = null;
      }

      if (!ack.ok || payload?.message) {
        var message =
          payload?.message ||
          "Une erreur s'est produite lors de la preparation de votre location.";
        window.postMessage({ type: "greenleazeError", message: message }, "*");
        return false;
      }

      if (payload?.redirectUrl) {
        window.location.href = payload.redirectUrl + "&duration=" + duration;
        return true;
      }

      window.postMessage(
        {
          type: "greenleazeError",
          message: "Aucune URL de redirection n'a ete retournee.",
        },
        "*",
      );
      return false;
    } catch (error) {
      console.error("Greenleaze redirect failed", error);
      window.postMessage(
        {
          type: "greenleazeError",
          message: error?.message || "Une erreur s'est produite. Veuillez reessayer.",
        },
        "*",
      );
      return false;
    }
  }

  function handleWindowMessage(event) {
    if (event.data?.type !== "submitGreenleazeModal") {
      return;
    }

    sendCartAndRedirect(
      event.data?.duration,
      event.data?.variantId,
      event.data?.pdistinctId,
    ).then(function(success) {
      if (!success) {
        return;
      }

      [
        "#modal-abonnement-product--greenleaze",
        "#modal-abonnement-cart--greenleaze",
      ].forEach(function(selector) {
        var modal = document.querySelector(selector);
        if (modal) {
          modal.style.display = "none";
        }
      });
    });
  }

  window.Greenleaze = {
    version: "2.0.0",
    getAllPriceRules: getAllPriceRules,
    getRuleByProductPriceAndDuration: getRuleByProductPriceAndDuration,
    getAllPricesForProduct: getAllPricesForProduct,
    sendCartAndRedirect: sendCartAndRedirect,
    addTo: addTo,
    get monthValues() {
      return monthValues.slice();
    },
    get trackingId() {
      return getTrackingId();
    },
  };

  window.greenleazeScript = true;
  window.initGreenleazeScript = true;
  window.initPriceGreenleaze = Boolean(window.initPriceGreenleaze);
  window.getAllPriceRules = getAllPriceRules;
  window.getRuleByProductPriceAndDuration = getRuleByProductPriceAndDuration;
  window.getAllPricesForProduct = getAllPricesForProduct;
  window.sendCartAndRedirect = sendCartAndRedirect;
  window.addTo = addTo;

  window.addEventListener("message", handleWindowMessage);

  getAllPriceRules().catch(function() {
    return null;
  });
})(window);
